import React from 'react';
import { Switch, Redirect } from 'react-router-dom';

import { RouteWithLayout } from './components';
import { Main as MainLayout, Minimal as MinimalLayout } from './layouts';

import {
  SearchCarApplies as SearchCarAppliesView,
  SearchFireAndInjuryApplies as SearchFireAndInjuryAppliesView,
  Detail,
  NotFound as NotFoundView,
  Users as UsersView,
} from './views';

const Routes = () => {
  return (

    <Switch>
      <Redirect exact from='/' to='/search/car' />
      <RouteWithLayout
        component={SearchCarAppliesView}
        exact
        layout={MainLayout}
        path='/search/car'
      />
      <RouteWithLayout
        component={SearchFireAndInjuryAppliesView}
        exact
        layout={MainLayout}
        path='/search/fire-and-injury'
      />
      <RouteWithLayout
        component={UsersView}
        exact
        layout={MainLayout}
        path='/user/list'
      />
      <RouteWithLayout
        component={Detail}
        exact
        layout={MinimalLayout}
        path='/detail'
      />
      <RouteWithLayout
        component={NotFoundView}
        exact
        layout={MinimalLayout}
        path='/not-found'
      />
      <Redirect to='/not-found' />
    </Switch>
  );
};

export default Routes;
